module.exports = __webpack_public_path__ + "static/media/ckMeetRepTam.3d0533f9.jpg";